import { Component, ElementRef, Injector, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';
import { LoginpagemessagesService } from '../../main-layout/loginpagemessages/loginpagemessages.service';
import { Utilityservice } from '../../utility/utilityservice.service';
import { BaseClass } from '../../utility/baseClass';

@Component({
  selector: 'app-loginpagemessagesmodal',
  templateUrl: './loginpagemessagesmodal.component.html',
  styleUrls: ['./loginpagemessagesmodal.component.css']
})
export class LoginpagemessagesmodalComponent extends BaseClass implements OnInit {
  maxDate = new Date();
  myForm: FormGroup
  tableData: any[] = [];
  isView: any;
  saveTitle = 'Add'
  isEdit: boolean = false;
  rId = null;
  dataDetails: any = {}
  CSRFToken = "";
  helpid: null;
  characterCount: number = 0;
  activeFlag = [
    { 'labelname': 'Yes', 'value': 'Y' },
    { 'labelname': 'No', 'value': 'N' }
  ]
  fromDate: any;
  toDate: any;
  errorDIsplay = false;
  onlyView: boolean = false;
  viewModules = {
    toolbar: [] // empty = no controls
  };

  public validation_message = {
    'fromdate': [{ type: 'required', message: 'From Date is required' }],
    'todate': [{ type: 'required', message: 'To Date is required' }],
    'activeflag': [{ type: 'required', message: 'Status Flag is required' }],
    'messagename': [
      { type: 'required', message: 'Login Page Message is required' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: 'Special characters are not allowed ( % and \' )' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
    ]
  }


  constructor(
    private LoginpagemessagesService: LoginpagemessagesService,
    private el: ElementRef,
    //private dashboardService: DashboardService,
    private Utilityservice: Utilityservice,
    public router: Router, private fb: FormBuilder,
    public override  injector: Injector,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private spinnerservice: NgxSpinnerService
  ) {
    super(injector);
    this.maxDate.setDate(this.maxDate.getDate());
    const dataFromParent = this.config.data;
    this.gettoken();
    if (dataFromParent?.title == 'Modify') {
      this.saveTitle = 'Modify'
      this.isEdit = true;
      this.dataDetails = dataFromParent.datas
    }
    if (dataFromParent?.title == 'View') {
      this.isView = true;
      this.onlyView = true;
      this.saveTitle = 'View1'
      this.dataDetails = dataFromParent.datas;
      //          this.formInitiliaze();
      //              this.patchValueforView(this.dataDetails)

    }

  }

  ngOnInit() {
    this.formInitiliaze();
    this.getData()
  }
  getData() {
    if (this.isEdit) { this.patchValueForms(this.dataDetails) }
    if (this.isView) { this.patchValueforView(this.dataDetails) }
  }

  patchValueForms(data) {
    this.rId = data[0].rid;
    const fdate = new Date(data[0].fromdate);
    const tdate = new Date(data[0].todate);
    this.toDate = tdate; this.fromDate = fdate;
    this.myForm.patchValue({ 'messagename': data[0].messagename });
    this.myForm.patchValue({ 'fromdate': fdate });
    this.myForm.patchValue({ 'todate': tdate });
    this.myForm.patchValue({ 'activeflag': data[0].activeflag });
  }

  patchValueforView(data) {
    //        const datePipe = new DatePipe('en-GB');
    //        const fdate = datePipe.transform(data[0].fromdate, 'dd-mm-yyyy');
    //        const fdate = new Date(data[0].fromdate, 'dd-MM-yyyy');
    //        const tdate = new Date(data[0].todate);
    this.rId = data[0].rid;
    this.myForm.patchValue({ 'messagename': data[0].messagename });
    this.myForm.patchValue({ 'fromdate': data[0].fromdate });
    this.myForm.patchValue({ 'todate': data[0].todate });
    this.myForm.patchValue({ 'activeflag': data[0].activeflag });
  }

  dismiss() {
    Swal.fire({
      title: "Are you sure, you want to close?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "No",
      denyButtonText: `Yes`
    }).then((result) => {
      if (result.isDenied) {
        this.ref.close();
      }
    });
  }


  formInitiliaze() {
    this.myForm = this.fb.group({
      fromdate: ['', Validators.compose([Validators.required])],
      todate: ['', Validators.compose([Validators.required])],
      activeflag: ['', Validators.compose([Validators.required])],
      messagename: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(2000),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)
      ])]
    })
  }
  // Add New DBScript
  add() {

    if (this.myForm.invalid) {
      Swal.fire({
        icon: 'warning',
        title: 'Please fill up all the mandatory/required fields and then save!',
        customClass: { icon: 'custom-skyblue-icon' },
        willClose: () => {
          this.validateAllFormFields(this.myForm, this.el);
          setTimeout(() => {
            const firstInvalidControl = document.querySelector('.ng-invalid') as HTMLElement | null;
            if (firstInvalidControl) {
              const focusable = firstInvalidControl.querySelector<HTMLElement>(
                'input, select, textarea, [tabindex]:not([tabindex="-1"])'
              );
              if (focusable && !focusable.closest('p-calendar')) {
                focusable.focus();
              }
              else {
                firstInvalidControl.tabIndex = -1;
                firstInvalidControl.focus();
              }
            }
          }, 10);
        }
      });
    }


    else if (this.myForm.get('todate').value != undefined && (this.myForm.get('fromdate').value > this.myForm.get('todate').value)) {
      Swal.fire('From Date cannot be greater than To Date', '', 'error')
    }

    else {
      const payload = {
        messagename: this.myForm.get('messagename').value?.trim?.(),
        fromdate: moment(this.myForm.get('fromdate').value).format('DD-MMM-YYYY'),
        todate: moment(this.myForm.get('todate').value).format('DD-MMM-YYYY'),
        activeflag: this.myForm.get('activeflag').value,
        rid: this.rId,
        csrftoken: this.CSRFToken
      }
      if (this.isEdit) {
        this.modify(payload)
      } else {
        Swal.fire({
          title: "Do you want to save the changes?",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Save",
          denyButtonText: `Don't Save`
        }).then((value) => {
          if (value.isConfirmed) {
            this.spinnerservice.show();
            this.LoginpagemessagesService.add(payload).subscribe((data: any) => {
              this.spinnerservice.hide();
              if (data.processid === 'exists') {
                Swal.fire("Login Page Message already exists!", "", "error").then(() => {
                  this.ref.close()
                });
              }
              else {
                Swal.fire("Login Page Message is added successfully!", "", "success").then(() => {
                  this.ref.close()
                });
              }
            }, error => {
              this.spinnerservice.hide();
              Swal.fire(error.error.message, '', 'error').then(() => {

              });
            });

          } else if (value.isDenied) {
            Swal.fire("Changes are not saved", "", "info")
            this.ref.close();
          }
        });

      }
    }

  }

  //Modify DB Script
  modify(data: any) {
    const payload = {
      messagename: this.myForm.get('messagename').value?.trim?.(),
      fromdate: moment(this.myForm.get('fromdate').value).format('DD-MMM-YYYY'),
      todate: moment(this.myForm.get('todate').value).format('DD-MMM-YYYY'),
      activeflag: this.myForm.get('activeflag').value,
      rid: this.rId,
      csrftoken: this.CSRFToken
    }

    Swal.fire({
      title: "Do you want to save the changes?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Save",
      denyButtonText: `Don't Save`
    })
      .then((value) => {
        if (value.isConfirmed) {
          this.spinnerservice.show();
          this.LoginpagemessagesService.modify(payload).subscribe(() => {
            this.spinnerservice.hide();
            Swal.fire("The Login Message is modified successfully!", "", "success").then(() => {
              this.ref.close()
            });
          }, error => {
            this.spinnerservice.hide();
            Swal.fire(error.error.message, '', 'error');
          });

        } else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info")
        }

      });

  }

  gettoken() {
    this.CSRFToken = '';
    this.Utilityservice.getCSRFtoken().subscribe(res => {
      this.CSRFToken = res.csrf;
    })

  }

  updateCharacterCount() {
    const value = this.myForm.get('helptext')?.value || '';
    this.characterCount = this.stripHtmlTags(value).length;
  }

  // Function to remove HTML tags and get plain text length
  stripHtmlTags(value: string): string {
    return value.replace(/<[^>]*>/g, ''); // Remove HTML tags
  }

  validateDates() {
    if (this.fromDate && this.toDate && this.toDate != null && this.fromDate > this.toDate) {
      this.errorDIsplay = true;
    } else {
      this.errorDIsplay = false;
    }
  }

  onClear() {
    this.fromDate = undefined!;
    this.toDate = undefined!;
  }

}
